import styled, { css } from 'styled-components';
import Typography from '@anwb/typography';
const stateContainerStyles = () => css `
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	margin-bottom: 16px;
`;
export const StateContainer = styled.div `
	${stateContainerStyles}
`;
export const explanationTextStyles = ({ theme, $colorContext, }) => `
	color: ${$colorContext === 'on-dark' ? theme.colors.blanc.textInverse : theme.colors.base.textBody};
`;
export const ExplanationText = styled(Typography).attrs({
    variant: 'body-text',
}) `
	${explanationTextStyles}
`;
//# sourceMappingURL=stories.styled.js.map